module.exports = __webpack_public_path__ + "static/media/img_0.ff8ef26f.png";